app.service('brandView', function (filterBox, nodeTree, lazyLoad, autocompleteInfo, pageConfig, loading, modal) {
	let $self, config, $paginationRoot, $paginationProgressBar, $paginationButton, $paginationProgressCount, visibleSections, $mostVisitedContainer;

	function setElements() {
		$self = $("#brand");
		config = pageConfig.getData('brand');
		$paginationRoot = $self.find('#brand-view-pagination');
		$paginationProgressBar = $self.find('.pagination-progress');
		$paginationButton = $self.find('.js-show-more-top-brands');
		$paginationProgressCount = $self.find('.brand-visible-count');
		$mostVisitedContainer = $self.find('.groups-with-products');
		visibleSections = $self.find('.section-sale').length || 0;
	}

	function setEvents() {
		$self.on('click', '.js-show-more-top-brands', function () {
			loadNextPage();
		});
	}

	function loadNextPage() {
		loading.start();

		$.ajax({
			url: '/brand-landing-page-most-visited-products-groups.ltr',
			data: {
				brandLinkName: config.brandLinkName,
				startFrom: visibleSections
			},
			success: function (html) {
				const $content = $('<div />').html(html).find('.brand-view-content').contents();
				$mostVisitedContainer.append($content);

				refreshVisibleSectionsCounter();
				updatePaginationProgress();

				if (visibleSections >= config.totalCategoriesCount) {
					$paginationRoot.addClass('hide');
				}
			},
			error: function () {
				modal.alert('Błąd podczas ładowania kolejnych grup produktowych');
			},
			complete: function () {
				loading.stop();
			}
		});
	}

	function refreshVisibleSectionsCounter() {
		visibleSections = $self.find('.section-sale').length || 0;
	}

	function updatePaginationProgress() {
		let visibleSectionsPercent = visibleSections/config.totalCategoriesCount*100;
		$paginationProgressBar.css('width', visibleSectionsPercent.toFixed(0) + '%');
		$paginationProgressCount.text(visibleSections);
	}

	function init() {
		setElements();
		setEvents();
		updatePaginationProgress();
		autocompleteInfo.logResult('brand', config);
		filterBox.init();
		nodeTree.init();
		new PreviewGallery({
			selector: $('.articles-list'),
			perPage: {
				0: 4
			},
			endOffset: 10,
			navigation: $('.articles-carousel-nav'),
			swipe: true,
			onChange() {
				lazyLoad.update();
			},
			onResize() {
				lazyLoad.update();
			},
			onInit: function onInit() {
				lazyLoad.update();
			}
		});

	}
	return {
		init
	};
});
